// deck.gl
// SPDX-License-Identifier: MIT
// Copyright (c) vis.gl contributors
export const DEFAULT_TILE_SIZE = 512;
export const DEFAULT_AGGREGATION_EXP_ALIAS = '__aggregationValue';
export const DEFAULT_AGGREGATION_EXP = `1 AS ${DEFAULT_AGGREGATION_EXP_ALIAS}`;
//# sourceMappingURL=constants.js.map